import StripePaymentForm from "@dreambigger/shared/src/components/stripe-payment-form";
export default StripePaymentForm;
